$(document).ready(function () {
  
  var $window = $(window);
  var sectionHeader = $('#shopify-section-header');
  var sectionHeaderHeight = sectionHeader.height();
  
  var sectionHeaderLock = $('.shopify-section-header-lock');
  if (sectionHeaderLock.length >= 1) {
	sectionHeaderLock.height(sectionHeaderHeight);
	sectionHeader.addClass('shopify-section-header-white');
  } else {
    $(document).scroll(function () {
      if ($window.scrollTop() > sectionHeaderHeight) {
          sectionHeader.addClass('shopify-section-header-white');
      } else {
          sectionHeader.removeClass('shopify-section-header-white'); 
      }
    });
  }
});